import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import InfoIcon from "@mui/icons-material/Info";
import {
  Card,
  CardActions,
  CardHeader,
  Drawer,
  InputLabel,  
  TextField,
  CardContent,
  Typography,
  Grid, 
  Box, 
  Divider,
  Checkbox,
  FormControlLabel 
} from "@mui/material";
import {
  Form,
} from "reactstrap";
import Popover from "./Popover";

function UserData(props) {
  const {
    selected,
    name,
    os_type,
    platform,
    handleSubmitClick,
    platformuserdata,
    userdata,
    setUserdata
  } = props;

  React.useEffect(() => {
      platformuserdata.map((usrdata) => {
        setUserdata((prevState) => ({
          ...prevState,
          [usrdata.variable]: usrdata.output,
        }));
      });      
  }, []);
  console.log(userdata)

  const handleChange = (e) => {
    const { id, value } = e.target;
    setUserdata((prevState) => ({
      ...prevState,
      [id]: value,
    }));    
  };

  const renderFields = (platformuserdata) => {
    return platformuserdata.map((field) => {
      let { no, name, output, variable, type, hint, only_applicable, header } =
        field;
        switch (type) {
          case "password":
            return (
              <React.Fragment>
                {field.based_on &&
                userdata[field.based_on] === only_applicable ? (
                  <React.Fragment>
                <Grid item md={6} xs={12}>
                    <InputLabel
                      style={{ fontSize: "small" }}
                      htmlFor="component-simple"
                    >
                      {" "}
                      {name} <Popover hint={hint} />
                    </InputLabel>
                    <TextField
                      id={variable}
                      value={userdata[variable]}
                      onChange={handleChange}
                      type={type}
                      fullWidth
                      size="medium"
                    />
                </Grid>
                  </React.Fragment>
                ) : !field.based_on ? (
                  <React.Fragment>
                <Grid item md={6} xs={12}>
                    <InputLabel
                      style={{ fontSize: "small" }}
                      htmlFor="component-simple"
                    >
                      {" "}
                      {name} <Popover hint={hint} />
                    </InputLabel>
                    <TextField
                      id={variable}
                      value={userdata[variable]}
                      onChange={handleChange}
                      type={type}
                      fullWidth
                      size="medium"
                    />
                </Grid>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </React.Fragment>
            );
          case "text":
            return (
              <React.Fragment>
                {field.based_on &&
                userdata[field.based_on] === only_applicable ? (
                  <React.Fragment>
                <Grid item md={6} xs={12}>
                    <InputLabel
                      style={{ fontSize: "small" }}
                      htmlFor="component-simple"
                    >
                      {" "}
                      {name} <Popover hint={hint} />
                    </InputLabel>
                    <TextField
                      id={variable}
                      value={userdata[variable]}
                      onChange={handleChange}
                      type={type}
                      fullWidth
                      size="medium"
                    />
                </Grid>
                  </React.Fragment>
                ) : !field.based_on ? (
                  <React.Fragment>
                <Grid item md={6} xs={12}>
                    <InputLabel
                      style={{ fontSize: "small" }}
                      htmlFor="component-simple"
                    >
                      {" "}
                      {name} <Popover hint={hint} />
                    </InputLabel>
                    <TextField
                      id={variable}
                      value={userdata[variable]}
                      onChange={handleChange}
                      type={type}
                      fullWidth
                      size="medium"
                    />
                </Grid>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </React.Fragment>
            );
          case "select":
            return (
              <React.Fragment>
                <Grid item md={6} xs={12}>
                <InputLabel
                  style={{ fontSize: "small" }}
                  htmlFor="component-simple"
                >
                  {" "}
                  {name} <Popover hint={hint} />
                </InputLabel>
                <TextField
                  id={variable}
                  value={userdata[variable]}
                  onChange={handleChange}
                  type={type}
                  fullWidth
                  size="medium"
                  select
                  SelectProps={{ native: true }}
                >
                  <option key="" value=""></option>
                  {field.options.map((row) => {
                    return (
                      <React.Fragment>
                        <option value={row}>{row}</option>
                      </React.Fragment>
                    );
                  })}
                </TextField>
                </Grid>
              </React.Fragment>
            );
          default:
            return (
              <div key={name}>
                <span className="red-text">
                  {name} {type}
                </span>
              </div>
            );
        }
    });
  };  
  return (
    <React.Fragment>
      <Card>
        <CardHeader title={`Platform: ${os_type}`} />
        <CardContent>
          <Form>
              <Drawer />
              {platformuserdata.length === 0 ? (
                ""
              ) : (
                <React.Fragment>
                  <Grid container justify="center" spacing={4}>
                  {renderFields(platformuserdata)}
                </Grid>                        
                </React.Fragment>
              )}
            </Form>
        <br />
            </CardContent>
        <br />
        <br />
        <CardActions style={{ float: "right" }}>
          <button
            className="bg-blueGray-600 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="button"
            style={{ float: "right" }}
          >
            <Link
              to={{
                pathname: "/admin/templates",
              }}
            >
              Cancel
            </Link>
          </button>
          <button
            className={
              name && os_type && selected.length > 0
                ? "bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                : "bg-lightBlue-200 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            }
            size="sm"
            onClick={handleSubmitClick}
            style={{ float: "right" }}
            disabled={name && os_type && selected.length > 0 ? false : true}
          >
            <Link
              to={{
                pathname: "/admin/templates",
              }}
            >
              Update
            </Link>
          </button>          
        </CardActions>
      </Card>
    </React.Fragment>
  );
}

export default UserData;